export const csvEscape = (value) => {
  return typeof value === 'string' ? value.replace(/"/g, '""') : value;
};
